import React, { Component } from "react";

import Header from "../common/HeaderAfterLogin";
import AuthHeader from "../salesUser/common/AuthHeader"
import { history } from "../../history/history";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstnace as axios, getDaysForDaysPackage, getSalesUserData } from "../../util/util";
import { endPoints, domain } from "../../config";
import Drag from "./dragNdDropaudiobrief";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import Editor from "draft-js-plugins-editor";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from "draft-js-buttons";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import "draft-js/dist/Draft.css";
const staticToolBarPlugin = createToolbarPlugin();
const ToolbarStatic = staticToolBarPlugin.Toolbar;
class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener("click", this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((
          Button,
          i // eslint-disable-next-line
        ) => (
          <Button key={i} {...this.props} />
        ))}
      </div>
    );
  }
}

class HeadlinesButton extends Component {
  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className="headlineButtonWrapper">
        <button onClick={this.onClick} className="headlineButton">
          H
        </button>
      </div>
    );
  }
}

const ComapignSuccess = (props) => {
  let { result } = props.location.state;
  const [uploadAudioBrief] = useState("drag_nd_drp");
  const [audioBrief, setAudioBrief] = useState(EditorState.createEmpty());
  const [uploadedAudioBrief, handleuploadedAudioBrief] = useState(undefined);
  const [fileName, handleFileName] = useState("");
  const [fileSizeWithLimit, setFileSizeWithLimit] = useState("");
  const [fileSize, handleFileSize] = useState("");
  const [editor, setEditor] = useState("");
  const [salesUserInfo, setSalesUserInfo] = useState(getSalesUserData());
  const [language, setLanguage] = useState("Hindi")
  const handleUploadedAudioBrief = (e) => {
    setAudioBrief(e);
  };
  const styles = {
    editor: {
      border: "1px solid gray",
      height: "16em",
      margin: "0 0 0-45%",
      width: "210%",
      overflow: "auto",
    },
  };
  const setEditorState = (editor) => {
    setEditor(editor);
  };
  const focusEditor = () => {
    if (editor) {
      editor.focus();
    }
  };

  const [option, handleOption] = useState(true);

  //Upload a file
  const getUploadedFile = (files) => {
    var size = bytesToSize(files.size);
    setFileSizeWithLimit(size);
    handleuploadedAudioBrief(files);
    handleFileName(files.name);
    handleFileSize(files.size);
  };

  // Show file size in bytes
  const bytesToSize = (bytes, decimals = 2) => {
    var sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes == 0) return "0 bytes";
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed()) + " " + sizes[i];
  };
  //Redirect to route bassed on path
  const goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //Remove a file
  const removeFile = () => {
    handleuploadedAudioBrief(undefined);
    handleFileSize("");
    handleFileName("");
  };

  //Redirect to campaign list
  const goToCompaignList = () => {
    history.push("/dashboard");
  };

  //Error handling
  const handleToastError = (error) => {
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,
      hideProgressBar: true,
      toastId: "1",
    });
  };

  const updateCampaign = async () => {
    let res = props.location.state;
    let campaign = res.result[0];
    
    if (!audioBrief.getCurrentContent().hasText() && !uploadedAudioBrief) {
      handleToastError("Enter AudioBrief to Proceed");
      return;
    }
    debugger
    if (!language) {
      handleToastError("Select language for audio Creation");
      return;
    }
    let convertedHTML = draftToHtml(
      convertToRaw(audioBrief.getCurrentContent())
    );
    let data = {
      _id: campaign._id,
      updateObj: {
        audioBrief: convertedHTML,
        uploadedAudioBrief,
        language,
        // uploadAudioBrief
      },
    };
    // await this.props.updateCompainAudio(endPoints.updateCampaignAudio, formData, '/dashboard');
    const result = await axios.post(endPoints.updateCampaign, data);
    
    if(salesUserInfo){
        window.location.pathname = 'tp/campaign'
    }else{
      goToRoute("updatedCampaign", result.data.data[0]    , "/dashboard")
    }
  };

  //Return a message when campaign created successfully
  return (
    <div className="main_wrapper">
      <div className="side_menu_wrapper">
        <div
          className="logo_header"
          onClick={() => {
            history.push({ pathname: "/" });
          }}
        >
          <img src="../../assets/images/dash_logo.png" />
        </div>
        <div className="menu_item_wrapper">
          <ul className="item_wrapper">
            <li className="item_inner active">
              {!salesUserInfo && <a
                onClick={() => {
                  history.push({ pathname: "/dashboard" });
                }}
              >
                <span>
                  <img
                    src="../../assets/images/campaingns.png"
                    className="white"
                  />
                  <img
                    src="../../assets/images/campaingns_sl.png"
                    className="blue"
                  />
                </span>
                <span>CAMPAIGNS</span>
              </a>
            
              }{salesUserInfo && <a
                onClick={() => {
                  window.location.pathname = "/tp/campaign"
                }}
              >
                <span>
                  <img
                    src="../../assets/images/campaingns.png"
                    className="white"
                  />
                  <img
                    src="../../assets/images/campaingns_sl.png"
                    className="blue"
                  />
                </span>
                <span>CAMPAIGNS</span>
              </a>
            
              }
              </li>
            <li className="item_inner">
              <a
                onClick={() => {
                  history.push({ pathname: "/contact" });
                }}
              >
                <span>
                  <img
                    src="../../assets/images/telephone.svg"
                    className="white"
                  />
                  <img
                    src="../../assets/images/contactus_sl.png"
                    className="blue"
                  />
                </span>
                <span>CONTACT US</span>
              </a>
            </li>
          </ul>
        </div>
        <p className="copyright_txt">
          Copyright @2019 BigFM. All Rights Reserved
        </p>
      </div>
      <div className="dashboard_right_wrapper">
        <div className="right_wrapper_inner">
          <Header />
          {!salesUserInfo && <Header/>}
        {salesUserInfo && <AuthHeader />}

          <div className="dash_content_wrapper">
            <div className="content_wrapper_inner">
              <div className="bookcampaign">
                <div>
                  <img
                    src="../../assets/images/tick.png"
                    className="saved_camp"
                  />
                </div>
                <div className="success_camp_created">
                  {result[0].payId && 
                  "Campaign Successfully Created !"}
                  {!result[0].payId && 
                  "Campaign created and the payment verification is pending with the BIGFM Team"}
                </div>
                <div className="book_camp_para success_camp_para">
                  <p>Campaign ID : {result ? result[0]._id : ""}</p>
                </div>
                {result &&
                  result[0].bigFmAudio &&
                  result[0].bigFmAudio === "true" && (
                    <div className="audio_brief">
                      <div onClick={focusEditor} style={styles.editor}>
                        <Editor
                          ref={setEditorState}
                          placeholder="Enter Audio Brief"
                          editorState={audioBrief}
                          onChange={handleUploadedAudioBrief}
                          plugins={[staticToolBarPlugin]}
                        />
                      </div>
                      <div>
                        <ToolbarStatic>
                          {// may be use React.Fragment instead of div to improve perfomance after React 16
                          (externalProps) => (
                            <div>
                              <BoldButton {...externalProps} />
                              <ItalicButton {...externalProps} />
                              <UnderlineButton {...externalProps} />
                              <CodeButton {...externalProps} />
                              <Separator {...externalProps} />
                              <HeadlinesButton {...externalProps} />
                              <UnorderedListButton {...externalProps} />
                              <OrderedListButton {...externalProps} />
                              <BlockquoteButton {...externalProps} />
                              <CodeBlockButton {...externalProps} />
                            </div>
                          )}
                        </ToolbarStatic>
                        <div style={{marginTop: "15px", marginBottom: "15px"}}>
                                    <label for="language" style={{fontWeight: "500", fontSize: ".85em"}}>Select Language</label>
                                    <select className="packageType drop-down-icon status-dropdown" id="language" onChange={ (e) => { setLanguage(e.target.value) } } value={language}>
                                      <option value=""></option>{" "}
                                      <option value="Assamese">Assamese</option>{" "}
                                      <option value="Bengali">Bengali</option>{" "}
                                      <option value="English">English</option>{" "}
                                      <option value="Gujarati">Gujarati</option>{" "}
                                      <option value="Hindi">Hindi</option>{" "}
                                      <option value="Kannada">Kannada</option>{" "}
                                      <option value="Khasi">Khasi</option>{" "}
                                      <option value="Konkani">Konkani</option>{" "}
                                      <option value="Malayalam">Malayalam</option>{" "}
                                      <option value="Marathi">Marathi</option>{" "}
                                      <option value="Oriya">Oriya</option>{" "}
                                      <option value="Punjabi">Punjabi</option>{" "}
                                      <option value="Tamil">Tamil</option>{" "}
                                      <option value="Telugu">Telugu</option>{" "}
                                      <option value="Tulu">Tulu</option>{" "}
                                    </select>
                                  </div>
                
                      </div>
                    </div>
                  )}

                <div className="book_camp_btn">
                  {result &&
                    result[0].bigFmAudio &&
                    result[0].bigFmAudio === "true" && (
                      <button onClick={updateCampaign}>
                        Submit Audio Brief
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ComapignSuccess;



// WEBPACK FOOTER //
// ./web/components/campaign/CompaignSuccess.jsx